export default function useNormalizedThumbnailUrl (thumbnailUrl: string) {
  thumbnailUrl = thumbnailUrl.trim();

  const regEx = /d_(\d+)x(\d+)$/;

  const matches = thumbnailUrl.match(regEx);

  if (!matches) {
    return thumbnailUrl;
  }

  const [width, height] = matches.slice(1).map(entry => parseInt(entry, 10));

  const aspectRatio = width / height;

  const newWidth = 800;
  const newHeight = Math.round(newWidth / aspectRatio);

  const result = thumbnailUrl.replace(regEx, `d_${newWidth}x${newHeight}`);

  return result;
}
